import { render, staticRenderFns } from "./country-add.vue?vue&type=template&id=62ad47f1&scoped=true&"
import script from "./country-add.vue?vue&type=script&lang=js&"
export * from "./country-add.vue?vue&type=script&lang=js&"
import style0 from "./country-add.vue?vue&type=style&index=0&id=62ad47f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad47f1",
  null
  
)

export default component.exports